module.exports = __webpack_public_path__ + "static/img/announcement.121e3456.svg";